import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModulesManagerService } from '../../classes/Module/modules-manager.service';
import { AuthToken } from '../../classes/AuthToken/auth-token';
import { LoggerService } from '../../utils/logger.service';

@Component({
  selector: 'app-token-view',
  templateUrl: './token-view.component.html',
  styleUrls: ['./token-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TokenViewComponent implements OnInit {

  @ViewChild('confirmaction') confirmAlert;
  public get UserId(): number {
    return this.userId
  }

  public set UserId(id: number) {
    this.userId = parseInt(id + "")
    this.manager.deleteModuleData("AuthTokens")
    if (this.userId > 0)
      this.manager.LoadList("AuthTokens", "User", this.userId)
  }


  private userId: number = 0;

  constructor(public manager: ModulesManagerService) { }

  get Tokens(): Array<AuthToken> {
    return (this.userId > 0 ? this.manager.GetListModuleData("AuthTokens", "User", this.userId) : []).sort((token1, token2) => token2.LastUse - token1.LastUse)
  }

  async Delete(token: AuthToken) {
    this.confirmAlert.presentAlert({
      header: this.manager.Trad.Parse('STR_DELETE_TOKEN'),
      message: this.manager.Trad.Parse('STR_DELETE_TOKEN_DESCRIPTION'),
      cssClass: 'confirm-delete-alert',
      buttons: [
        {
          text: this.manager.Trad.Parse('STR_DELETE'),
          handler: async () => {
            const Id = token.Id
            let result = await this.manager.Ws.Send("AuthTokens", "Delete", { Id: Id }, true).catch(err => LoggerService.error('Erreur lors de la suppression du token', err))
            if (result?.success) {
              this.manager.deleteModuleData("AuthTokens", Id)
              this.manager.Tool.notify(this.manager.Trad.Parse(result.success))
            }
          },
          cssClass: 'delete-button',
        },
        {
          text: this.manager.Trad.Parse('STR_CLOSE'),
        },
      ],
    })

  }

  ngOnInit() { }

}
